import FileUploadApi from "../services/api/fileUploadApi";

export const uploadFileToServer = async (formData, onUploadProgress) => {
  try {
    const response = await FileUploadApi.uploadFile(formData, onUploadProgress);
    return response;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "File upload failed");
  }
};
